module.exports = __webpack_public_path__ + "static/media/sidebar_grammar_blue.2495a042.svg";